import { useEffect, useState } from "react";

const Pagination = (props) => {
  const {
    page,
    setPage,
    perPageOptions = [5, 10, 20, 50, 100, 500],
    pageSizeOnly = false,
  } = props;
  const [pageContent, setPageContent] = useState([]);
  const pagerSize = Math.ceil(page.totalCount / page.itemsPerPage);

  // Generate Dynamic Page Numbers (Keeps Current Page Centered)
  useEffect(() => {
    let templist = [];
    const { currentPage, pageCount } = page;

    if (pagerSize <= pageCount) {
      // If total pages are less than or equal to pageCount, show all pages
      for (let i = 1; i <= pagerSize; i++) {
        templist.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - Math.floor(pageCount / 2));
      let endPage = Math.min(pagerSize, startPage + pageCount - 1);

      // Ensure we always display exactly `pageCount` pages
      if (endPage - startPage + 1 < pageCount) {
        startPage = Math.max(1, endPage - pageCount + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        templist.push(i);
      }
    }

    setPageContent(templist);
  }, [page.currentPage, page.itemsPerPage, page.pageCount]);

  // Change Page Number
  const setCurrentPageNo = (pageNo) => {
    setPage({ ...page, currentPage: pageNo });
  };

  // Handle Previous Page
  const setPrevious = () => {
    if (page.currentPage > 1) {
      setPage({ ...page, currentPage: page.currentPage - 1 });
    }
  };

  // Handle Next Page
  const setNext = () => {
    if (page.currentPage < pagerSize) {
      setPage({ ...page, currentPage: page.currentPage + 1 });
    }
  };

  // Handle Items Per Page Change
  const changeItemsPerPage = (items) => {
    setPage({ ...page, itemsPerPage: items, currentPage: 1 });
  };

  return (
    <div className="d-flex align-items-center gap-2">
      {!pageSizeOnly ? (
        <nav aria-label="Pagination">
          <ul className="pagination m-0">
            <li
              className={`page-item ${page.currentPage <= 1 ? "disabled" : ""}`}
            >
              <button
                className="page-link"
                onClick={setPrevious}
                disabled={page.currentPage <= 1}
              >
                &laquo;
              </button>
            </li>

            {pageContent.map((item) => (
              <li
                key={item}
                className={`page-item ${
                  page.currentPage === item ? "active" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPageNo(item)}
                >
                  {item}
                </button>
              </li>
            ))}

            <li
              className={`page-item ${
                page.currentPage >= pagerSize ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={setNext}
                disabled={page.currentPage >= pagerSize}
              >
                &raquo;
              </button>
            </li>
          </ul>
        </nav>
      ) : (
        <div
          style={{
            color: "#767483",
            fontSize: "13px",
            fontWeight: "500px",
          }}
        >
          Select limit
        </div>
      )}

      <div className="dropdown">
        <button
          className="btn btn-outline-primary dropdown-toggle"
          type="button"
          id="itemsPerPageDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {page.itemsPerPage}
        </button>
        <ul className="dropdown-menu" aria-labelledby="itemsPerPageDropdown">
          {perPageOptions.map((size) => (
            <li key={size}>
              <button
                className="dropdown-item"
                onClick={() => changeItemsPerPage(size)}
              >
                {size}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {!pageSizeOnly && (
        <span>
          Showing{" "}
          {Math.min(page.currentPage * page.itemsPerPage, page.totalCount)} of{" "}
          {page.totalCount} Results
        </span>
      )}
    </div>
  );
};

export default Pagination;
